export const WorkItemDetails = {
    GET_ALLWORKITEMS: "GET_ALLWORKITEMS",
    UPDATE_ALLWORKITEMS: "UPDATE_ALLWORKITEMS",
    POST_ALLWORKITEMS: "POST_ALLWORKITEMS",
    GET_ALLWORKCATEGORY: "GET_ALLWORKCATEGORY",
    REMOVE_WORKITEMSEARCH: "REMOVE_WORKITEMSEARCH",
    GET_WORKITEMSWITHSUPPORT: "GET_WORKITEMSWITHSUPPORT",
}
